import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2"; // Importar SweetAlert2
import "./ExistenciasSucursal.css";

const SubirExistenciasSucursal = () => {
  const [archivo, setArchivo] = useState(null);
  const [sucursal, setSucursal] = useState("");
  const [categoria, setCategoria] = useState("");

  const handleArchivoChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleSubirArchivo = async (e) => {
    e.preventDefault();
    if (!archivo || !sucursal || !categoria) {
      Swal.fire({
        title: "Campos incompletos",
        text: "Por favor ingresa la sucursal, categoría y selecciona un archivo XML.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", archivo);
    formData.append("sucursal", sucursal);
    formData.append("almacen", categoria);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/sucursales/upload-existencias-sucursal/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      Swal.fire({
        title: "Archivo subido correctamente",
        text: `Sucursal: ${sucursal} - Categoría: ${categoria}`,
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      Swal.fire({
        title: "Error al subir el archivo",
        text: "Hubo un problema al subir el archivo. Por favor, inténtalo nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };


  const almacenes = ["GC1", "GC2", "GP1", "GP2", "OFERTAS", "PD", "PEPSI-COCA"];

  return (
    <div className="subir-existencias-container">
      <h2>Subir Existencias por Sucursal</h2>
      <form onSubmit={handleSubirArchivo}>
        <input type="file" accept=".xml" onChange={handleArchivoChange} required />
        <input
          type="text"
          placeholder="Sucursal"
          value={sucursal}
          onChange={(e) => setSucursal(e.target.value)}
          required
        />
        <select
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
          required
        >
          <option value="">ALMACEN</option>
          {almacenes.map((alm) => (
            <option key={alm} value={alm}>{alm}</option>
          ))}
        </select>
        {/* <input
          type="text"
          placeholder="Almacen"
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
          required
        />
        <p className="indicacion-almacen"> Ingresa el almacen como: GC1, GC2, GP1, GP2, u OFERTAS</p> */}
        <button type="submit">Subir Archivo</button>
      </form>
    </div>
  );
};

export default SubirExistenciasSucursal;